import React, { memo } from 'react'
import moment from 'utils/momentInstanse'
import { Skeleton } from '@material-ui/lab'

import Title from 'components/CommonUI/Title/Title'

const LastUpdateBlock = ({ date = null }) => {
  const _date = moment.utc(date).toDate()
  return (
    <div className="last_update_block_container">
      <Title
        title="Last data update"
        component="span"
        className="last_update_title"
        withTooltip={true}
        tooltipText="Data is updated every 15 minutes"
      />
      <span className="last_update_date">
        {date ? (
          moment(_date).format('MMMM D, yyyy [at] HH:mm')
        ) : (
          <Skeleton variant="text" width={'100%'} />
        )}
      </span>
    </div>
  )
}

export default memo(LastUpdateBlock)
